<template>
    <div class="vxe-table--ignore-clear">
    <el-popover
        popper-class="orders-popover-content vxe-table--ignore-clear"
        placement="bottom"
        :disabled="isEdit"
        width="800px"
        v-model="visible"
        trigger="click">
        <div class="dag-content">
            <el-row :gutter="10"   >
                <el-col :span="6" > 
                    <!-- <div class="prop-lable">型号：</div> -->
                    <el-input v-model="formData.itemCode" placeholder="请输入型号"></el-input>
                </el-col>
                <el-col :span="6" > 
                    <!-- <div class="prop-lable">品牌：</div> -->
                    <el-input v-model="formData.brandName" placeholder="请输入品牌" ></el-input>
                </el-col>
                <el-col :span="6" > 
                    <!-- <div class="prop-lable">货物名称：</div> -->
                    <el-input v-model="formData.itemName" placeholder="请输入货物名称" ></el-input>
                </el-col>
                <el-col :span="6" style="text-align: right;}">
                    <el-button   @click="searchForm" >查询</el-button>
                    <el-button link class="btn-svg" @click="resetForm"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
            <el-table :data="gridData" border @row-dblclick="checkedRowData" v-loading="isloading" class="vxe-table--ignore-clear">
                <el-table-column  property="itemCode" label="型号" show-overflow-tooltip></el-table-column>
                <el-table-column  property="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column  property="itemName" label="货物名称" show-overflow-tooltip></el-table-column>
                <el-table-column  property="originPlaceName" label="产地" show-overflow-tooltip></el-table-column>
                <el-table-column  property="price" label="单价" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column  property="productSpec" label="产品参数" show-overflow-tooltip></el-table-column> -->
            </el-table>
            <div style="margin-top:5px;text-align: center;" class="list-page">
                    <ab-page
                    :pageTotal="page.total" 
                    :currentPage='page.currentPage' 
                    :pageSize="page.pageSize" 
                    :pageSizes="page.pageSizes"
                    @searchForm="pageSearch"
                    layout="prev, pager, next"
                    ></ab-page>
             </div>
        </div>
        <template #reference>
            <el-input  @input="handleKeyUp" @focus="handleFocus(row)" :disabled="isEdit" v-model="row[fileName]" @change="inputChange($event, row)" @blur="inputBlur(row)" placeholder="请输入" >
                <template #append v-if="isAppend">
                    <slot></slot>
                </template>
            </el-input>
        </template>
    </el-popover>
</div>
</template>

<script>
import cal from '@/utils/calculation'
export default {
    data () {
        return {
            gridData: [],
            visible: false,
            isloading: false,
            keyupDone: true,
            tid: '',
            formData: {
               
            },
            page: {
                currentPage: 1,
                pageSize: 5,
                pageSizes: [5, 10, 20, 50],
                total: 0
            },
        }
    },
    props: ['row', 'fileName', 'isEdit', 'isAppend', 'sourceType'],
    methods: {
        checkedRowData (obj) {
            this.row.model = obj.itemCode //品牌
            this.row.brand = obj.brandName// 型号
            this.row.productSpec = obj.productSpec//产品参数
            this.row.custMatNo = obj.clientNumber//料号
            this.row.materialName = obj.itemName//品名
            this.row.customsCodeName = obj.customsCode//海关编码
           // this.row.isInspection = obj.isInspectionImpDesc == '是' ? true : false //是否商检
            if (obj.isInspectionImpDesc == '是') {
                this.row.isInspection = true
            } else if (obj.isInspectionImpDesc == '否') {
                this.row.isInspection = false
            }
            this.row.isInspectionDesc = obj.isInspectionImpDesc
            this.row.importTariffRate = obj.enterShutTaxRate //关税率
            if (obj.itemUnitName != "Pcs") {
                this.row.baseUnitId = obj.itemUnitId //单位
                this.row.baseUnitName = obj.itemUnitName
            }
            this.row.originPlaceName = obj.originPlaceName
            this.row.originPlaceId = obj.originPlaceId
            this.row.price = obj.price
            let sum = 0
            if (obj.price && this.row.qty) {
                sum = cal.mul(obj.price, this.row.qty)
            }
            // if (this.sourceType == 'out') {
            //     console.log(obj.exitRetreatTaxrate)
            //     this.row.exportRebateRate = obj.exitRetreatTaxrate
            // }
            this.row.amount = sum.toFixed(2) || 0
            this.row.isMultiComponent = obj.isMultiComponent
            this.row.materialId = obj.relateItemId
            this.row.itemPrincipalId = obj.id
            this.row.inspectionQuarantineCategory  = obj.inspectionQuarantine
            this.row.customsCodeId = obj.customsCodeId
            this.row.isChangeKey = false
            this.visible = false
            console.log(this.row)
            this.$emit('change', this.row)
            this.$emit('clearActived')
        },
        pageSearch (obj) {
            this.page.currentPage = obj.currentPage
            this.page.pageSize = obj.pageSize
            this.getDataList(this.formData)
        },
        searchForm () {
            this.page.currentPage = 1
            this.getDataList(this.formData)
        },
        getDataList (formData, flag) {
            this.isloading = true
            let data = Object.assign(formData, {pageNum: this.page.currentPage, pageSize: this.page.pageSize})
            this.$post('/wmsbase/client/clientItemPrincipal/pageListAll', data, this, 'isloading').then(res => {
                if (res.data && res.data.code === 'C0000') {
                    this.gridData = res.data.result.list
                    this.page.total = res.data.result.total
                    console.log(this.gridData, flag)
                    if (this.gridData.length == 1 && flag) {
                        if (formData.itemCode.toLocaleUpperCase() == this.gridData[0].itemCode.toLocaleUpperCase()) {
                            this.checkedRowData(this.gridData[0])
                        }
                    }
                }
            })
        },
        inputChange (e, row) {
            this.formData.itemCode = e
            this.$emit('change', row)
        },
        handleKeyUp (e) {
            console.log(e)
            // if (e.target.value && e.target.value.length > 0) {
            //     this.throttling(this.changeKeyUp, e)
            // }
            this.throttling(this.changeKeyUp, e)
        },
        changeKeyUp (e) {
            this.page.currentPage = 1
            this.row[this.fileName] = e
            this.keyupDone = false
            this.visible = true
            this.formData.itemCode = e
            this.getDataList({itemCode: e.trim()})
        },
        throttling (fn, e) {
            let that = this, args = arguments
            clearTimeout(this.tid)
            this.tid = setTimeout(function() {
                fn(e)
            }, 500) 
        },
        handleFocus (row) {
            this.getDataList({itemCode: row.model})
        },
        resetForm () {
            this.formData = {}
        },
        inputBlur (row) {
            this.getDataList({itemCode: row.model}, true)
        }
    },
    watch: {
        visible (v) {
            if (v) {
                if (this.keyupDone) {
                    console.log(this.row[this.fileName])
                    this.formData.itemCode = this.row[this.fileName]
                    this.getDataList(this.formData)
                }
            } else {
                this.keyupDone = true
            }
        }
    }

}
</script>

<style lang="scss">
.orders-popover-content {
    .el-form-item {
        margin: 10px 10px 8px;
    }
    
    padding: 0 10px 10px 10px;
    
    
    .el-form-item__label {
        line-height: 28px;
    }
    .dag-content {
        margin: 0 30px;
        padding-top: 10px;
        .dag-li {
            div {
                width: 42px;
                font-size: 12px ;
                line-height: 28px;
                float: left;
            }
            .el-input {
                width: calc(100% - 42px);
            }
        }
        .dag-li1 {
            div {
                width: 62px;
                font-size: 12px ;
                line-height: 28px;
                float: left;
            }
            .el-input {
                width: calc(100% - 62px);
            }
        }
        .el-table {
            margin-top: 20px;
        }
        
    }
    .prop-lable {
        margin-top: 8px;
    }
}
</style>